import React, { useState } from 'react';

const TestSubtitle = () => {
  const [logs, setLogs] = useState([]);
  const [subtitles, setSubtitles] = useState([]);

  const addLog = (message, type = 'info') => {
    const time = new Date().toLocaleTimeString();
    setLogs(prev => [...prev, { time, message, type }]);
  };

  const parseSRT = (srtContent) => {
    addLog('开始解析SRT字幕');
    const subtitles = [];
    const blocks = srtContent.trim().split(/\n\s*\n/);
    
    addLog(`发现 ${blocks.length} 个字幕块`);
    
    blocks.forEach((block, blockIndex) => {
      const lines = block.split('\n');
      if (lines.length >= 3) {
        const timeLine = lines[1];
        const timeMatch = timeLine.match(/(\d{2}):(\d{2}):(\d{2}),(\d{3})\s*-->\s*(\d{2}):(\d{2}):(\d{2}),(\d{3})/);
        
        if (timeMatch) {
          const startHours = parseInt(timeMatch[1]);
          const startMinutes = parseInt(timeMatch[2]);
          const startSeconds = parseInt(timeMatch[3]);
          const startMs = parseInt(timeMatch[4]);
          const startTime = startHours * 3600 + startMinutes * 60 + startSeconds + startMs / 1000;
          
          const textLines = lines.slice(2);
          let english = '';
          let chinese = '';
          
          textLines.forEach(line => {
            if (/[\u4e00-\u9fa5]/.test(line)) {
              chinese += (chinese ? ' ' : '') + line;
            } else if (line.trim()) {
              english += (english ? ' ' : '') + line;
            }
          });
          
          subtitles.push({
            time: startTime,
            english: english.trim(),
            chinese: chinese.trim()
          });
        }
      }
    });
    
    addLog(`解析完成，共 ${subtitles.length} 个字幕`, 'success');
    return subtitles;
  };

  const loadSubtitlesFromFile = async (subtitleUrl) => {
    addLog(`从字幕文件加载: ${subtitleUrl}`);
    
    let fullUrl = subtitleUrl;
    if (!subtitleUrl.startsWith('http')) {
      if (!subtitleUrl.startsWith('/')) {
        fullUrl = `/${subtitleUrl}`;
      } else {
        fullUrl = subtitleUrl;
      }
    }
    
    addLog(`完整字幕URL: ${fullUrl}`);
    
    try {
      addLog(`正在发送请求到: ${fullUrl}`);
      const response = await fetch(fullUrl, {
        method: 'GET',
        mode: 'cors'
      });
      
      addLog(`HTTP状态码: ${response.status}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const content = await response.text();
      addLog(`字幕文件内容长度: ${content.length}`);
      addLog(`字幕文件前100字符: ${content.substring(0, 100)}`);
      
      let parsedSubtitles = [];
      
      if (subtitleUrl.toLowerCase().endsWith('.srt')) {
        parsedSubtitles = parseSRT(content);
        addLog(`SRT字幕解析完成，数量: ${parsedSubtitles.length}`, 'success');
      }
      
      if (parsedSubtitles.length > 0) {
        addLog('准备显示字幕', 'success');
        setSubtitles(parsedSubtitles);
        return true;
      } else {
        addLog('解析到的字幕为空', 'error');
        return false;
      }
    } catch (error) {
      addLog(`加载字幕文件失败: ${error.message}`, 'error');
      console.error(error);
      return false;
    }
  };

  const testLoadSubtitles = async () => {
    addLog('开始测试字幕加载（无空格文件）');
    const subtitleUrl = '/uploads/subtitles-1772448762006.srt';
    const success = await loadSubtitlesFromFile(subtitleUrl);
    
    if (success) {
      addLog('字幕加载测试成功！', 'success');
    } else {
      addLog('字幕加载测试失败！', 'error');
    }
  };

  const testLoadSubtitlesWithSpaces = async () => {
    addLog('开始测试字幕加载（有空格文件）');
    const subtitleUrl = '/uploads/1772527732287-How your digestive system works - Emma Bryce.srt';
    const success = await loadSubtitlesFromFile(subtitleUrl);
    
    if (success) {
      addLog('字幕加载测试成功！', 'success');
    } else {
      addLog('字幕加载测试失败！', 'error');
    }
  };

  const clearSubtitles = () => {
    setSubtitles([]);
    addLog('字幕已清除');
  };

  const clearLogs = () => {
    setLogs([]);
  };

  return (
    <div style={{ 
      fontFamily: 'Arial, sans-serif', 
      margin: '20px', 
      backgroundColor: '#f5f5f5',
      padding: '20px'
    }}>
      <div style={{ 
        maxWidth: '800px', 
        margin: '0 auto', 
        background: 'white', 
        padding: '20px', 
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ 
          color: '#333', 
          borderBottom: '2px solid #1a73e8', 
          paddingBottom: '10px'
        }}>
          简单字幕加载测试
        </h1>
        
        <div>
          <button 
            onClick={testLoadSubtitles}
            style={{
              background: '#1a73e8',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              margin: '5px'
            }}
          >
            加载字幕（无空格）
          </button>
          <button 
            onClick={testLoadSubtitlesWithSpaces}
            style={{
              background: '#28a745',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              margin: '5px'
            }}
          >
            加载字幕（有空格）
          </button>
          <button 
            onClick={clearSubtitles}
            style={{
              background: '#6c757d',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              margin: '5px'
            }}
          >
            清除字幕
          </button>
          <button 
            onClick={clearLogs}
            style={{
              background: '#dc3545',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              margin: '5px'
            }}
          >
            清除日志
          </button>
        </div>
        
        <h2 style={{ color: '#333', marginTop: '20px' }}>日志</h2>
        <div style={{ 
          background: '#f8f9fa', 
          border: '1px solid #dee2e6', 
          borderRadius: '4px', 
          padding: '10px', 
          margin: '20px 0', 
          maxHeight: '300px', 
          overflowY: 'auto', 
          fontFamily: 'monospace', 
          fontSize: '12px'
        }}>
          {logs.map((log, index) => (
            <div 
              key={index} 
              style={{ 
                margin: '5px 0', 
                padding: '5px', 
                borderLeft: `3px solid ${log.type === 'error' ? '#dc3545' : log.type === 'success' ? '#28a745' : '#1a73e8'}`,
                paddingLeft: '10px',
                color: log.type === 'error' ? '#dc3545' : log.type === 'success' ? '#28a745' : '#333'
              }}
            >
              [{log.time}] {log.message}
            </div>
          ))}
        </div>
        
        <h2 style={{ color: '#333' }}>字幕内容</h2>
        <div style={{ marginTop: '20px' }}>
          {subtitles.slice(0, 10).map((subtitle, index) => (
            <div 
              key={index} 
              style={{ 
                margin: '10px 0', 
                padding: '15px', 
                border: '1px solid #e0e0e0', 
                borderRadius: '8px', 
                background: '#fafafa'
              }}
            >
              <div style={{ 
                color: '#666', 
                fontSize: '12px', 
                marginBottom: '5px'
              }}>
                {Math.floor(subtitle.time / 60).toString().padStart(2, '0')}:{(subtitle.time % 60).toFixed(0).padStart(2, '0')}
              </div>
              <div style={{ 
                color: '#333', 
                fontWeight: 'bold', 
                fontSize: '16px', 
                marginBottom: '5px'
              }}>
                {subtitle.english}
              </div>
              <div style={{ 
                color: '#666', 
                fontSize: '14px'
              }}>
                {subtitle.chinese || '(无中文字幕)'}
              </div>
            </div>
          ))}
          {subtitles.length > 10 && (
            <div style={{ 
              textAlign: 'center', 
              padding: '10px', 
              color: '#666'
            }}>
              ... 还有 {subtitles.length - 10} 个字幕
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TestSubtitle;
